export const ContestRulesLink = () => {
  return <div className="team-link-contest-rules align-self-center align-self-md-start my-3"><a href="/team/contest-rules">View Full Contest Rules</a></div>
}

export const ContestRulesLinkWhite = () => {
  return <div className="team-link-contest-rules"><a className="white" href="/team/contest-rules">View Full Contest Rules</a></div>
}
